"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainId = void 0;

var validation_1 = require("../validation");
/**
 * Different supported chain ids
 * @alpha
 */


var ChainId;

(function (ChainId) {
  ChainId[ChainId["ETHEREUM_MAINNET"] = 1] = "ETHEREUM_MAINNET";
  ChainId[ChainId["ETHEREUM_ROPSTEN"] = 3] = "ETHEREUM_ROPSTEN";
  ChainId[ChainId["ETHEREUM_RINKEBY"] = 4] = "ETHEREUM_RINKEBY";
  ChainId[ChainId["ETHEREUM_GOERLI"] = 5] = "ETHEREUM_GOERLI";
  ChainId[ChainId["ETHEREUM_KOVAN"] = 42] = "ETHEREUM_KOVAN";
  ChainId[ChainId["MATIC_MAINNET"] = 89] = "MATIC_MAINNET";
  ChainId[ChainId["MATIC_MUMBAI"] = 13881] = "MATIC_MUMBAI";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
/**
 * @alpha
 */


(function (ChainId) {
  ChainId.schema = {
    type: 'number',
    enum: Object.values(ChainId)
  };
  ChainId.validate = validation_1.generateValidator(ChainId.schema);
})(ChainId = exports.ChainId || (exports.ChainId = {}));